import { Component, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { createMenuItems } from './menu-items';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuGroupComponent } from './menu-group/menu-group.component';
import { MenuHeaderComponent } from './menu-header/menu-header.component';

/**
 * EXCEPTION: This component does NOT use PrimeNG.
 * Custom sidebar built with Tailwind for full styling control.
 */
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    imports: [MenuItemComponent, MenuGroupComponent, MenuHeaderComponent],
})
export class SidebarComponent {
    private readonly translateService = inject(TranslateService);

    private allMenuItems = createMenuItems(this.translateService);

    mainItems = computed(() => this.allMenuItems.filter((item) => !item.isBottom));
    bottomItems = computed(() => this.allMenuItems.filter((item) => item.isBottom));
}
